import { useState } from "react";
import Loading from "../../../../components/loading";
import Error from "../../../../components/Error";
import { Typography, Grid } from "@mui/material";
import { useRestaurant } from "../../../../hooks/RestaurantContext";
import ProductCard from "../../../../components/card";
import NoData from "../../../../components/noData";
import { ellipsisText } from "../../../../global/functions/textFormat";
import ParagraphHighliter from "../../../../components/paragraphHighliter";
import { useTranslation } from "react-i18next";
import ShowMultiItems from "../../../../components/showMultiItems";
import { CardPrice, CardStatus } from "../../../../components/cardMeta";
import ProductDetailsModal from "../../../../components/productDetailsModal";
import { useIsMobile } from "../../../../hooks/uiHook";

const CardViewProduct = ({
  filteredProducts,
  handleModify,
  handleDiscount,
  handleClickOpen,
  status,
  error,
  search,
}) => {
  const { t } = useTranslation();
  const { currency } = useRestaurant();
  const isMobile = useIsMobile();
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [detailsProduct, setDetailsProduct] = useState(null);

  const handleViewDetails = (product) => {
    setDetailsProduct(product);
    setDetailsOpen(true);
  };

  return (
    <Grid container spacing={2}>
      {status === "loadingFetchData" ? (
        <Loading />
      ) : status === "fetchError" ? (
        <Error>{error}</Error>
      ) : (
        <>
          {filteredProducts && filteredProducts.length > 0 ? (
            filteredProducts.map((card) => (
              <ProductCard
                key={card._id}
                data={card}
                handleModify={() => handleModify(card)}
                handleDiscount={handleDiscount}
                onViewDetails={handleViewDetails}
                search={search}
                content={
                  <>
                    <CardPrice
                      label={t("fields.price")}
                      price={
                        card.discountValue && card.discountValue > 0
                          ? card.discountedPrice
                            ? card.discountedPrice.toFixed(2)
                            : (card.originalPrice - card.discountValue).toFixed(2)
                          : card?.price ?? 0
                      }
                      oldPrice={
                        card.discountValue && card.discountValue > 0
                          ? card.originalPrice ?? card.price
                          : null
                      }
                      currency={currency}
                    />
                    {!isMobile && card.type?.length > 0 && (
                      <ShowMultiItems
                        items={card.type}
                        text={t("fields.optionsLabel")}
                      />
                    )}
                    {card.description && card.description !== "" && (
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={
                          isMobile
                            ? {
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }
                            : undefined
                        }
                      >
                        {t("fields.description")}:{" "}
                        <ParagraphHighliter
                          title={isMobile ? card?.description : ellipsisText(card?.description, 80)}
                          search={search}
                        />
                      </Typography>
                    )}
                    <CardStatus
                      outOfStock={card.outOfStock}
                      visible={card.visible}
                    />
                  </>
                }
                handleClickOpen={() => handleClickOpen(card._id)}
              />
            ))
          ) : (
            <NoData />
          )}
          <ProductDetailsModal
            open={detailsOpen}
            onClose={() => {
              setDetailsOpen(false);
              setDetailsProduct(null);
            }}
            product={detailsProduct}
            currency={currency}
            onEdit={() => {
              setDetailsOpen(false);
              handleModify(detailsProduct);
            }}
            onDelete={() => {
              setDetailsOpen(false);
              handleClickOpen(detailsProduct._id);
            }}
            onDiscount={() => {
              setDetailsOpen(false);
              handleDiscount(detailsProduct);
            }}
          />
        </>
      )}
    </Grid>
  );
};

export default CardViewProduct;
